import React from "react";
import cs from "classnames";
import "./styles.scss";
import CheckIcon from "../../../assets/Icon/CheckIcon";

interface LineSelectProps {
  size?: string;
  wrapperClassName?: string;
  labelClass?: string;
  active: boolean;
  title: string;
  id: number | null | undefined;
  onSelect?: ({ active, id }: any ) => void;
  list?: Array<any> | undefined;
  setList?: (updateData: any) => void;
  isOneSelect?: boolean | undefined;
}

const LineSelect: React.FC<LineSelectProps> = ({
  size = "default",
  wrapperClassName = "",
  labelClass = "",
  active = false,
  title = "",
  id = null,
  onSelect = (p: { active: boolean; id: any }) => null,
  list = [],
  setList,
  isOneSelect = false,
}) => {
  const handleSelect = (data) => {
    const updateData = list?.map((val) => {
      if (val.id === id) {
        return {
          ...val,
          isSelect: isOneSelect ? true : !active,
        };
      }
      return {
        ...val,
        isSelect: isOneSelect ? false : val.isSelect,
      };
    });
    if (setList) {
      setList(updateData);
    }
  };

  return (
    <div
      className={cs(
        "LineSelect",
        { [wrapperClassName]: wrapperClassName },
        { ["small-select"]: size === "small" },
        { ["default-select"]: size === "default" },
        { ["full-select"]: size === "full" },
        { ["active"]: active }
      )}
      onClick={handleSelect}
    >
      <span className={cs("lineSelect-label ", { [labelClass]: labelClass })}>
        {title}
      </span>
      <span className="check-icon-wrapper">
        <CheckIcon className="check-icon" />
      </span>
    </div>
  );
};
export default LineSelect;
